import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { speedTestInsightsDomainConfigEdit_template } from "../components/templates/speedTestInsightsDomainConfigEdit_template";

declare var ko: any;
declare var page: any;

export class speedTestInsightsDomainConfigEdit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected validationsList: validationsList_template;
    protected editForm: speedTestInsightsDomainConfigEdit_template;

    protected getModuleName(){

        return "speedTestInsightsDomainConfigEdit";
    }

    public buildContent(): Array<Element>{

        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the pageSpeed form
        this.editForm = new speedTestInsightsDomainConfigEdit_template("editForm", this.viewModel, this);

        return [this.editForm.build()];
    }

    public fillPage(): void{

        this.getFormData();
    }

    public getFormData(): void{

        let usrReq_url: string = '/api/speedTest/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormData;
        this.XHRHdl.execute();
    }

    protected onGetFormData(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getEditData();
                }
            });
        }
    }

    protected getEditData(): void{

        let id = this.getVnAppZone().app.params.id || null;
        let idPageType = this.getVnAppZone().app.params.idPageType || null;

        if (id) {
            this.loadingIn(this.editForm.builtTemplate);

            let subViewModel = {
                idDomain: id,
                urlPageType: idPageType,
            };

            let usrReq_url: string = '/api/speedTest/configInsights/get/' + id + '/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
            this.XHRHdl.execute();
        }
    }

    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                obj.editForm.setId(response.pageSpeedDomain.id);
                obj.editForm.setDomainName(response.pageSpeedDomain.domain);
                obj.editForm.setPortfolio(response.portfolio);
                obj.editForm.setType(response.type);
                obj.editForm.setPageType(response.pageType);
                obj.editForm.setUrls(response.urls);
                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected getPageTypeUrls(): void{

        let id = this.getVnAppZone().app.params.id || null;

        if (id) {
            this.loadingIn(this.editForm.builtTemplate);

            let subViewModel = {
                idDomain: id,
                urlPageType: this.editForm.getTemplateViewModel().pageTypeField.selectedOption
            };

            let usrReq_url: string = '/api/speedTest/configInsights/get/' + id + '/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetPageTypeUrls;
            this.XHRHdl.execute();
        }
    }

    protected onGetPageTypeUrls(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.editForm.setUrls(response.urls);
                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.editForm.setDomains(responseParsed.domains);
        this.editForm.setPortfolios(responseParsed.portfolios);
        this.editForm.setPageTypes(responseParsed.pageTypes);
        this.editForm.setTypes(responseParsed.types);
    }

    protected filterDropdownOnChange(idElement) {

        let id = this.getVnAppZone().app.params.id || null;

        if (id) {

            if (idElement == 'pageTypeField') {

                this.getPageTypeUrls();
            }
        }
    }

    protected cancel(){

        // Redirect to config list.
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Domain configuration action canceled !");

        page.redirect('/speed_test/config_insights/');
    }

    protected save(): void{

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.editForm.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/speedTest/configInsights/save', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Domain configuration saved successfully!');

                obj.validationsList.clearMessages();

                let response = JSON.parse(req.request.response);

                let id = response.idDomain;
                let idPageType = response.idPageType;

                page.redirect('/speed_test/config_insights/edit/' + id + '/' + idPageType + '/');
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/speedTestInsightsDomainConfigEdit.ts